import axios from 'axios';

export const getMenuService = async () => {
  const tenantData = localStorage.getItem('tenantId');
  return await axios.get(`tenant/${JSON.parse(tenantData).id}/menu/guest`);
};
